<template>
  <div class="page flex-v">
    <HeaderNav :topLevel="true" />
    <div class="container flex">
      <div class="leftBox">
        <img
          class="tit"
          src="https://llss-file.langsounds.com/miniapp/6b964208abd7f5691dd1665795f954e4.png"
          alt=""
        />
        <div class="intro flex-v">
          <span>全国 <span class="num">15273</span> 名教师正在使用 </span>
          <span>朗朗书声语文朗读教学平台（诵读资源库）</span>
          <span>进行辅助教学</span>
        </div>
      </div>
      <div class="rightBox">
        <div class="content">
          <slot></slot>
        </div>
        <!-- <p class="txt">Powered by 广州优谷信息技术有限公司</p> -->
      </div>
    </div>
    <FooterNav />
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  background: url("~images/cont_bg.png") no-repeat;
  background-size: cover;
  padding: 5% 100px 0 180px;
  box-sizing: border-box;
  justify-content: space-between;

  .leftBox {
    padding-top: 40px;

    .tit {
      width: 443px;
      height: 38px;
      object-fit: contain;
    }

    .intro {
      margin-top: 16px;
      line-height: 32px;
      color: #666666;
      font-size: 16px;

      .num {
        font-size: 24px;
        color: #ffac00;
      }
    }
  }

  .rightBox {
    height: 473px;

    .content {
      min-height: 446px;
      min-width: 400px;
      background: #ffffff;
      box-shadow: 0px 10px 16px 0px rgba(221, 139, 45, 0.1);
      border-radius: 24px;
    }
    .txt {
      color: #b58450;
      font-size: 12px;
      text-align: center;
      margin-top: 24px;
    }
  }
}
</style>
